import { FlexBox, InputField, SelectField, useLocationOptions } from '@esg/ui';
import React, { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';
import { setupRules } from '../@shared';

import IntroduceTour from '../introduce-tour/IntroduceTour';
import { translateCodes } from '@/locales';

export const Info = () => {
    const {phoneCodeOptions, allCountries} = useLocationOptions('', '');
    const { watch, setValue } = useFormContext();

    useEffect(() => {
        if (!watch('phoneCountryId') && watch('countryCode')) {
            setValue('phoneCountryId', allCountries?.find(x => x.phonecode === watch('countryCode'))?.id);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch('countryCode'), allCountries]);
    
    return (
        <>
            <IntroduceTour />
            <FlexBox justifyContent='space-between' gap={16}>
                <InputField
                    name='name'
                    label={translateCodes.BUSINESS_NAME}
                    placeholder={translateCodes.BUSINESS_NAME_PLACEHOLDER}
                    rules={setupRules.business}
                />
                <InputField
                    addonBefore={
                        <SelectField
                            showSearch
                            allowClear
                            style={{ width: 150 }}
                            name='phoneCountryId'
                            options={phoneCodeOptions}
                            onChange={(val) => {
                                setValue('countryCode', allCountries?.find((o) => o.id === val)?.phonecode);        
                            }}
                        />
                    }
                    name='phoneNumber'
                    label={translateCodes.PHONE_NUMBER}
                    placeholder={translateCodes.PHONE_PLACEHOLDER}
                    rules={setupRules.phone}
                />
            </FlexBox>
        </>
    );
};
